import React, { Component, createRef, useState, useEffect } from "react";
import { Row, Col, Card, Button, Table, Space, Typography, Skeleton, Input, Modal, Tooltip } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faTrash } from "@fortawesome/free-solid-svg-icons";
import _ from "lodash";

const NEW_ITEM_CATEGORY_BASE_STATE = { name: "" };

function ItemCategories(props) {
  const [itemCategories, setItemCategories] = useState([]);
  const [filteredItemCategories, setFilteredItemCategories] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");

  const [selectedItemCategory, setSelectedItemCategory] = useState(null);
  const [editModalOpen, setEditModalOpen] = useState(false);

  const [deleteModalOpen, setDeleteModalOpen] = useState(false);

  const [addModalOpen, setAddModalOpen] = useState(false);
  const [newItemCategory, setNewItemCategory] = useState(NEW_ITEM_CATEGORY_BASE_STATE);

  const table_columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      render: (text) => <Typography.Title level={5}>{text}</Typography.Title>,
      sorter: (a, b) => (a.name > b.name ? 1 : -1),
      defaultSortOrder: "ascend",
    },
    {
      title: "Items Using This Category",
      dataIndex: "applicable_items",
      key: "applicable_items",
      render: (text) => <Tooltip title={text}>{_.truncate(text, { separator: ", ", length: 128 })}</Tooltip>,
    },
    {
      title: "Actions",
      align: "right",
      dataIndex: "id",
      key: "id",
      render: (text, row) => (
        <Space>
          <Button
            size="small"
            type="primary"
            onClick={() => {
              setEditModalOpen(true);
              setSelectedItemCategory(itemCategories.find((f) => f.id === text));
            }}
          >
            <FontAwesomeIcon icon={faEdit} className="mr-1" />
            Edit
          </Button>
          <Button
            size="small"
            danger
            onClick={() => {
              setDeleteModalOpen(true);
              setSelectedItemCategory(itemCategories.find((f) => f.id === text));
            }}
          >
            <FontAwesomeIcon icon={faTrash} className="mr-1" />
            Delete
          </Button>
        </Space>
      ),
    },
  ];

  const GetItemCategories = async () => {
    let response = await props.AxiosRequest("/api/item-categories/get");
    setItemCategories(response.data.item_categories);
    setFilteredItemCategories(response.data.item_categories);
  };
  const UpdateItemCategory = async () => {
    await props.AxiosRequest("/api/item-categories/update", { id: selectedItemCategory.id, name: selectedItemCategory.name });
    GetItemCategories();
    setEditModalOpen(false);
    setSelectedItemCategory(null);
  };
  const DeleteItemCategory = async () => {
    await props.AxiosRequest("/api/item-categories/delete", { id: selectedItemCategory.id });
    GetItemCategories();
    setDeleteModalOpen(false);
    setSelectedItemCategory(null);
  };
  const AddItemCategory = async () => {
    if (newItemCategory.name.length === 0) return props.MakeNotification("info", "Please Enter All Required Fields.");
    await props.AxiosRequest("/api/item-categories/insert", { name: newItemCategory.name });
    GetItemCategories();
    setAddModalOpen(false);
    setNewItemCategory(NEW_ITEM_CATEGORY_BASE_STATE);
  };

  useEffect(() => {
    GetItemCategories();
  }, []);

  useEffect(() => {
    if (searchTerm?.length === 0) return setFilteredItemCategories(itemCategories);
    let filtered_list = itemCategories.filter((f) => (_.toLower(f.name).indexOf(_.toLower(searchTerm)) > -1 || _.toLower(f.applicable_items).indexOf(_.toLower(searchTerm)) > -1 ? true : false));
    setFilteredItemCategories(filtered_list);
  }, [searchTerm]);

  return (
    <main className="content">
      <div className="container-fluid">
        <div className="header">
          <h1 className="header-title">Item Categories</h1>
        </div>
        <Row>
          <Card
            title={<>Item Categories</>}
            style={{
              width: "100%",
            }}
            extra={
              <>
                <Button
                  type="primary"
                  onClick={() => {
                    setNewItemCategory(NEW_ITEM_CATEGORY_BASE_STATE);
                    setAddModalOpen(true);
                  }}
                >
                  <FontAwesomeIcon icon="plus" className="me-2" />
                  Add A New Item Category
                </Button>
              </>
            }
          >
            <Row>
              <Col span={18}></Col>
              <Col span={6}>
                <Input
                  className="mb-2"
                  value={searchTerm}
                  onChange={(e) => {
                    setSearchTerm(e.target.value);
                  }}
                  placeholder="Search..."
                  allowClear
                />
              </Col>
            </Row>
            <Table columns={table_columns} dataSource={filteredItemCategories} />
          </Card>
        </Row>
        <Modal
          title={"Edit Item Category"}
          centered
          open={editModalOpen}
          onCancel={() => {
            setEditModalOpen(false);
            setSelectedItemCategory(null);
          }}
          footer={
            <>
              <Button
                onClick={() => {
                  setEditModalOpen(false);
                  setSelectedItemCategory(null);
                }}
              >
                Cancel
              </Button>
              <Button
                type="primary"
                onClick={() => {
                  UpdateItemCategory();
                }}
              >
                Save Changes
              </Button>
            </>
          }
        >
          {selectedItemCategory ? (
            <>
              <label className="col-form-label-sm">Item Category Name *</label>
              <Input
                value={selectedItemCategory.name}
                onChange={(e) => {
                  setSelectedItemCategory({ ...selectedItemCategory, name: e.target.value });
                }}
              />
            </>
          ) : null}
        </Modal>

        <Modal
          title={"Are you sure?"}
          centered
          open={deleteModalOpen}
          onCancel={() => {
            setDeleteModalOpen(false);
            setSelectedItemCategory(null);
          }}
          footer={
            <>
              <Button
                onClick={() => {
                  setDeleteModalOpen(false);
                  setSelectedItemCategory(null);
                }}
              >
                Cancel
              </Button>
              <Button
                type="primary"
                danger
                onClick={() => {
                  DeleteItemCategory();
                }}
              >
                Delete
              </Button>
            </>
          }
        >
          {selectedItemCategory ? <>Are you sure you want to delete the item category {selectedItemCategory?.name}?</> : null}
        </Modal>

        <Modal
          title={"Add A New Item Category"}
          centered
          open={addModalOpen}
          onCancel={() => {
            setAddModalOpen(false);
            setSelectedItemCategory(null);
          }}
          footer={
            <>
              <Button
                onClick={() => {
                  setAddModalOpen(false);
                  setSelectedItemCategory(null);
                }}
              >
                Cancel
              </Button>
              <Button
                type="primary"
                onClick={() => {
                  AddItemCategory();
                }}
              >
                Add
              </Button>
            </>
          }
        >
          {newItemCategory ? (
            <>
              <label className="col-form-label-sm">Item Category Name *</label>
              <Input
                value={newItemCategory.name}
                onChange={(e) => {
                  setNewItemCategory({ ...newItemCategory, name: e.target.value });
                }}
              />
            </>
          ) : null}
        </Modal>
      </div>
    </main>
  );
}

export default ItemCategories;
